import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { can } from "@/lib/roles";
import { CashChoice } from "@/components/wh/SellRemoveDialog";

export function BulkSellDialog({ open, onOpenChange, count, onConfirm }) {
  const { user } = useAuth();
  const [total, setTotal] = useState("");
  const [cash, setCash] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await onConfirm({ total_price: total === "" ? null : Number(total), cash_kind: cash || null });
    setBusy(false);
    if (ok) { setTotal(""); setCash(""); onOpenChange(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="bulk-sell-dialog">
        <DialogHeader><DialogTitle>Vendi {count === 1 ? "1 selezionato" : `${count} selezionati`}</DialogTitle><DialogDescription>Tutte le unità disponibili vengono segnate come vendute.</DialogDescription></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5"><Label>Importo totale incassato (€)</Label>
            <Input type="number" step="0.01" min="0" value={total} onChange={(e) => setTotal(e.target.value)} placeholder="Es. 120,00" data-testid="bulk-total-input" />
            <p className="text-xs text-[var(--muted)]">Viene diviso tra gli articoli in proporzione alle unità. Lascia vuoto per usare il prezzo di vendita di ciascuno.</p></div>
          {can(user, "cash") && <CashChoice value={cash} onChange={setCash} />}
          <button disabled={busy} className="btn-primary h-11 px-5 w-full" data-testid="bulk-sell-confirm">{busy ? <Loader2 className="h-5 w-5 animate-spin" /> : null} Conferma vendita</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
